import { useState, useEffect } from "react";
import {
  Box,
  CardContent,
  Typography,
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  InputAdornment,
} from "@mui/material";
import BlockTableList from "./BlockTableList";
import { useDispatch, useSelector } from "react-redux";
import {
  blockNumberRequest,
  clearBlockMessages,
} from "../../../redux/Blocklist/BlocklistSlice";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getActiveCountriesRequest } from "../../../redux/CountryList/CountrySlice";
import auth from "../../../configs/auth";
import { canShowPermission } from "../Permissions/permissionObject";

const MIN_PHONE_LENGTH = 5;
const MAX_PHONE_LENGTH = 13;

const BlockList = () => {
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const blocklistState = useSelector((state) => state.blocklist || {});
  const { loading, successMessage, errorMessage } = blocklistState;
  const { activeCountries = [] } = useSelector((state) => state.country || {});

  const [selectedCountryId, setSelectedCountryId] = useState("");
  const [selectedDialCode, setSelectedDialCode] = useState("+91");
  const [selectedPhoneLength, setSelectedPhoneLength] = useState(10);

  const jeweller = sessionStorage.getItem(auth.selectedJeweller);
  const [selectedJewellerId, setSelectedJewellerId] = useState(() => {
      return sessionStorage.getItem(auth.selectedJeweller) || "";
    });
  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
  const jewellerID = storedUser?.jeweller;
   const finalJewellerId =
    selectedJewellerId && selectedJewellerId.trim() !== ""
      ? selectedJewellerId
      : jewellerID;
  useEffect(() => {
    dispatch(getActiveCountriesRequest({ jeweller :finalJewellerId}));
  }, [dispatch]);

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      setPhone("");
      dispatch(clearBlockMessages());
    }

    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(clearBlockMessages());
    }
  }, [successMessage, errorMessage, dispatch]);

  const handleSave = () => {
    const trimmedPhone = (phone || "").trim(); // trim input

    if (!trimmedPhone) {
      setError("Phone number is required.");
      return;
    }

    if (trimmedPhone.length !== selectedPhoneLength) {
      setError(`Phone number must be exactly ${selectedPhoneLength} digits`);
      return;
    }

    setError("");
    dispatch(blockNumberRequest({ phone: trimmedPhone }));

    // Optional loader simulation if API response is instant
    setTimeout(() => {
      setPhone(""); // clear input after "success"
    }, 2000); // adjust delay as needed
  };
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");
    if (storedPermissions) {
      try {
        setPermissions(JSON.parse(storedPermissions));
      } catch (e) {
        console.error("Invalid permissions JSON", e);
      }
    }
  }, []);

  const canCreateBlockList = canShowPermission(permissions, "blockCustomer", "create");

  return (
    <Box sx={{ width: "100%", height: "100vh", overflow: "auto" }}>
      <Box
        sx={{
          width: "100%",
          mt: 0,
          background: "#fff",
          borderRadius: "16px",
          mb: 2,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Typography fontWeight={700} fontSize={24} mb={2} p={2}>
          Block List
        </Typography>
        {canCreateBlockList && (
          <Box
            sx={{
              display: "flex",
              gap: 2,
              p: 2,
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            <FormControl
              size="small"
              sx={{ minWidth: { xs: "120px", sm: "120px" } }}
            >
              <InputLabel>Select Country</InputLabel>
              <Select
                value={selectedCountryId}
                label="Select Country"
                onChange={(e) => {
                  const selected = activeCountries.find(
                    (c) => c._id === e.target.value
                  );

                  setSelectedCountryId(e.target.value);
                  setSelectedDialCode(selected?.dialCode || "+91");
                  setSelectedPhoneLength(selected?.phoneLength || 10);
                  setPhone(""); // reset phone on country change
                  setError("");
                }}
              >
                <MenuItem value="" disabled>
                  <em>Select Country</em>
                </MenuItem>
                {activeCountries.map((country) => (
                  <MenuItem key={country._id} value={country._id}>
                    {country.countryCode}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              label={`Enter phone number (${selectedPhoneLength} digits)`}
              variant="outlined"
              size="small"
              placeholder={`Enter ${selectedPhoneLength} - digit number`}
              value={phone}
              onChange={(e) => {
                let digitsOnly = e.target.value.replace(/\D/g, "");
                if (digitsOnly.length <= selectedPhoneLength) {
                  setPhone(digitsOnly);
                }
              }}
              error={!!error}
              helperText={error}
              inputProps={{ maxLength: selectedPhoneLength }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {selectedDialCode}
                  </InputAdornment>
                ),
              }}
              sx={{ minWidth: { xs: "210px", sm: "332px" } }}
            />
            <Button
              variant="contained"
              onClick={handleSave}
              sx={{
                textTransform: "none",
                backgroundColor: "#752ADA",
                "&:hover": { backgroundColor: "#673AB7" },
              }}
              disabled={loading}
            >
              {loading ? "Saving..." : "Save"}
            </Button>
          </Box>
        )}
        <CardContent
          sx={{
            height: "580px",
            width: "100%",
          }}
        >
          <BlockTableList />
        </CardContent>
      </Box>
    </Box>
  );
};

export default BlockList;
